module.exports = __webpack_public_path__ + "static/img/producteBg.81ee6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producteBg.png
// module id = slgR
// module chunks = 1